import { createSelector } from "reselect";
import moment from 'moment';

const genericPs = state => state.genericPS.events;

const getData = (data) => {
  const genericPs = [...data];

  genericPs.forEach(item => {
    item.displayTimestamp = moment(item.timestamp).format("DD/MM/YYYY");
    item.displaySuccess = item.success ? "yes" : "no";
  });

  return genericPs;
};

export default createSelector(
  genericPs,
  getData
);



// WEBPACK FOOTER //
// ./src/selectors/get_generic_ps.js